<template>
  <div class="flex middle column">
    <div class="w1200 w100">
      <section class="grid-flex w100 center">
        <h1>Escolha uma conta para acessar:</h1>
      </section>
      <section class="flex w100 column middle">
        <div v-for="(acc, index) in accounts" :key="index" class="box account" style="margin-left: 0px;">
          <div class="box-content">
            <div class="flex middle">
              <div class="flex-2">
                <h3>({{ acc.id }}) {{ acc.name }}</h3>
              </div>
              <div class="flex-1 flex end">
                <div class="button primary" @click="selectAccount(acc)">
                  ENTRAR
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { AccountsList } from "@/services/user";

export default {
  name: "Account",
  components: {},
  data() {
    return {
      account: null,
      loading: false,
      accounts: [],
    };
  },
  mounted() {
    this.loading = true;

    AccountsList()
      .then((response) => {
        this.accounts = response;
        if (this.accounts.length) {
          this.account = this.accounts[0];
          // check exist one account...
          if (this.accounts.length === 1) {
            this.accountSelected();
          }
        }
      })
      .catch((error) => {
        if (error && error.message === "request-canceled") {
          return;
        }

        this.$toast.error({
          title: "Erro",
          message: "Falhou ao buscar contas",
        });
      })
      .finally(() => {
        this.loading = false;
      });
  },
  computed: {
    listAllAccounts() {
      if (!this.accounts || (this.accounts && this.accounts.length === 0)) {
        return [];
      }

      return this.accounts.map((acc) => {
        return {
          label: `(${acc.id}) ${acc.name}`,
          value: acc,
        };
      });
    },
  },
  methods: {
    selectAccount(account) {
      this.account = account;
      this.accountSelected();
    },
    accountSelected() {
      if (!this.account) {
        this.$toast.error({
          title: "Erro",
          message: "Você precisa selecionar uma conta para entrar!",
        });
        return;
      }

      // set in store user and account selected
      this.$store.dispatch("auth", { account: this.account.id });
      this.$store.dispatch("setAccount", this.account);

      // redict to home
      this.$router.push({ name: "Home" });
    },
  },
};
</script>

<style lang="scss" scoped>
.grid-flex {
  padding: 35px;
}

.w1200 {
  max-width: 1200px;
}

.account {
  margin-top: 16px;
  min-width: 450px;
}
</style>
